// extracted by mini-css-extract-plugin
export default {"container":"UserFormInfo_container__8tXO6","lastname-and-firstname-container":"UserFormInfo_lastname-and-firstname-container__vkKjF","error":"UserFormInfo_error__MbgXX"};